<template>
  <button
      type="button"
      class="btn btn-link clipboard-button"
      :class="'text-' + color"
      @click="copyToClipboard()"
      data-toggle="tooltip"
      data-placement="top"
      :title="tooltip"
      >
    <i class="fa" :class="'fa-' + icon" aria-hidden="true"></i>
    {{label}}
  </button>
</template>

<script>
module.exports = {
  props: {
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'clipboard',
    },
    color: {
      type: String,
      default: 'secondary',
    },
    value: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: 'Copy to clipboard!'
    }
  },
  methods: {
    copyToClipboard: function() {
      navigator.clipboard.writeText(this.value);
    }
  }
}
</script>
